import React, { useState } from "react";
import axios from "axios";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../../components/ui/dialog";
import { Label } from "../../../components/ui/label";
import { Checkbox } from "../../../components/ui/checkbox";

const MasterAccessActionBar = ({ onRefresh, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [formData, setFormData] = useState({
    Username: "",
    LocationAccess: false,
    CategoryAccess: false,
    UnitAccess: false,
    ItemAccess: false,
  });
  const [error, setError] = useState(null);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  const handleAddClick = () => {
    setFormData({
      Username: "",
      LocationAccess: false,
      CategoryAccess: false,
      UnitAccess: false,
      ItemAccess: false,
    });
    setIsAddDialogOpen(true);
  };

  const handleSave = async () => {
    try {
      const accessData = {
        LocationAccess: formData.LocationAccess ? 1 : 0,
        CategoryAccess: formData.CategoryAccess ? 1 : 0,
        UnitAccess: formData.UnitAccess ? 1 : 0,
        ItemAccess: formData.ItemAccess ? 1 : 0,
      };

      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/master-access`,
        {
          ...accessData,
          Username: formData.Username,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      onRefresh();
      setIsAddDialogOpen(false);
      setError(null);
    } catch (error) {
      console.error("Error saving master access:", error);
      setError("Failed to save master access");
    }
  };

  const handleClose = () => {
    setIsAddDialogOpen(false);
    setError(null);
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center space-x-4">
        <Input
          type="text"
          placeholder="Search users..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-64"
        />
        <Button onClick={onRefresh}>Refresh</Button>
      </div>
      <div className="flex items-center space-x-4">
        <Dialog open={isAddDialogOpen} onOpenChange={setIsAddDialogOpen}>
          <DialogTrigger>
            <Button onClick={handleAddClick}>Add User</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Add User Access</DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <Label htmlFor="username">Username</Label>
                <Input
                  id="username"
                  value={formData.Username}
                  onChange={(e) => setFormData({ ...formData, Username: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="locationAccess"
                    checked={formData.LocationAccess}
                    onCheckedChange={(checked) =>
                      setFormData({ ...formData, LocationAccess: checked })
                    }
                  />
                  <Label htmlFor="locationAccess">Location Access</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="categoryAccess"
                    checked={formData.CategoryAccess}
                    onCheckedChange={(checked) =>
                      setFormData({ ...formData, CategoryAccess: checked })
                    }
                  />
                  <Label htmlFor="categoryAccess">Category Access</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="unitAccess"
                    checked={formData.UnitAccess}
                    onCheckedChange={(checked) =>
                      setFormData({ ...formData, UnitAccess: checked })
                    }
                  />
                  <Label htmlFor="unitAccess">Unit Access</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="itemAccess"
                    checked={formData.ItemAccess}
                    onCheckedChange={(checked) =>
                      setFormData({ ...formData, ItemAccess: checked })
                    }
                  />
                  <Label htmlFor="itemAccess">Item Access</Label>
                </div>
              </div>
              {error && <div className="text-red-500">{error}</div>}
              <div className="flex justify-end space-x-2">
                <Button variant="outline" onClick={handleClose}>
                  Cancel
                </Button>
                <Button onClick={handleSave}>Save</Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default MasterAccessActionBar; 